import React,{useState, useRef, useEffect} from "react"
import FooterMenu from "./FooterMenu"
import FooterQuickMenu from "./FooterQuickLinksMenu"
import Twitcker from "./FeefoWidget.js"
import Cookies from 'universal-cookie';
import { useLocation } from "@reach/router";

function scrollToTop () {
  window.scrollTo({top: 0,
  behavior: 'smooth'})
}

const Footer = props => {
const cookies = new Cookies();
const [clicked, setClicked] = useState(false);

function closeDetails(index) {
  setClicked(false);
  cookies.set('modal_message', 'closed', { path: '/' });
}
console.log(clicked)
   useEffect(() => {
     if(cookies.get('modal_message')==='closed'){
       setClicked(false);
     }
     console.log(cookies.get('modal_message'))
   }, [setClicked]);

  return (
    <>
    <footer className="content navy-background">
  <div className="eighty-spacer"></div>
  <div className="content-block">
     <div className="one-flex-container">

        <div className="third-flex-container">
                 <div className="footer-heading-holder">
                    Quick Links
                 </div>
                 <div className="footer-menu-container">
                 <FooterQuickMenu />
                 </div>
           </div>
           <div className="third-flex-container pad-left-eighty smaller-footer-col">
                     <div className="footer-heading-holder">
                        Get in touch
                     </div>
                     <div className="footer-social-list-holder">
                        <ul>
                        <li>
                       <a href="https://www.linkedin.com/company/hampshire-trust-bank/?trk=biz-companies-cym" target="_blank" rel="noopener noreferrer">
                          <span className="linkedin-white-icon"></span>
                       </a>
                       </li>
                      <li>
                       <a href="https://twitter.com/htbplc" target="_blank" rel="noopener noreferrer">
                          <span className="twitter-white-icon"></span>
                       </a>
                       </li>
                      </ul>
                      </div>
              </div>
              <div className="third-flex-container footer-logos-col-fix">
               <div className="footer-logos-holder">
                  <ul>
                                                <li>
                                                               <a href="#">
                                    <img src="/htbcontent/uploads/2019/06/fscs-protected-logo-1.png" alt="FSCS Protected - Hampshire Trust Bank" title="FSCS Protected – Hampshire Trust Bank"/>
                                 </a>
                                                         </li>

                                          </ul>
               </div>
            </div>


        </div>
        <div className="footer-legal-content-holder">
	&copy;2022 Hampshire Trust Bank Plc is authorised by the Prudential Regulation Authority and regulated by the Prudential Regulation Authority and the Financial Conduct Authority. Our FRN number is 204601. We are a company registered in England and Wales, registration number 01311315. Registered office: 55 Bishopsgate, London EC2N 3AS. Hampshire Trust Bank, HTB and <img className="alignnone wp-image-2751" src="/htbcontent/uploads/2020/01/Hants-logo-3-Copy-300x300.png" alt="" width="29" height="29"/>are registered trademarks of Hampshire Trust Bank Plc. </div>
        <div className="footer-secondary-menu-holder">
         <FooterMenu />
      </div>
     </div>
     <div className="eighty-spacer"></div>
     <div className="back-to-top-container" onClick={scrollToTop}>
      <img src="/htbcontent/themes/htb-personal/assets/img/back-to-top-button-mango.jpg" alt="Hampshire Trust Bank (HTB)" title="Hampshire Trust Bank (HTB)" width="60px" height="60px"/>
   </div>
   <Twitcker/>
    {/* .widget-area */}
    {/* .site-info */}
  </footer>
  <div id="covid" className={`${clicked ? 'modal active' : 'modal not-active'}`} style={{display: clicked ? 'inline-block' : 'none'}}>
<p>HTB would like to reassure customers that we are operating normal business hours, 9am to 5pm Monday to Friday with no interruptions to our service. <a href="/a-message-to-htb-customers-and-intermediaries/">Click here for more information about our response to COVID-19</a>. Please <a href="/about-us/contact/">get in touch here</a>, or via your usual method should you have any concerns.</p>
<a href="#" onClick={() => closeDetails()} className="close-modal">Close</a></div>
  </>
)
}

export default Footer
